import newsPostShare from '../components/news-post-share';
import scrollToElement from '../components/scroll-to-element';
import $ from 'jquery';

const shareButton = document.querySelector('.post__meta__share');
const shareMoreContent = document.querySelector('.post__meta__share__more');
const postMetaDate = document.querySelector('.post__meta__date');
const isLibraryCategory = document.body.classList.contains(
    'page--news-post--library'
);

export default function newsPost() {
    // shareButton.addEventListener('click', function() {
    // 	this.style.display = 'none';
    // 	shareMoreContent.style.display = 'block';
    // 	postMetaDate.classList.add('share-is-open');
    // })

    newsPostShare.init();

    if (isLibraryCategory) {
        setupDownloadButtonClickActions();
        setupDownloadFormSubmit();
    }
    commentsForm();
}

function setupDownloadFormSubmit() {
    $('.aside--download-form__form').submit(function (e) {
        e.preventDefault();
        downloadFile($('meta[name=gdl]').attr('content'));
        $(this).slideUp();
        $('.aside--download-form__container h4')
            .addClass('margin-bottom-none')
            .text('Thank you for downloading this digital download');
    });
}

function setupDownloadButtonClickActions() {
    const downloadButtons = document.querySelectorAll(
        '.is-library-download-button'
    );
    const downloadForm = document.querySelector('.aside--download-form');

    function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }

    function flashForm() {
        function removeFocusClass() {
            downloadForm.classList.remove('focus-in');
        }

        downloadForm.classList.add('focus-in');

        downloadForm.addEventListener(
            'webkitAnimationEnd',
            removeFocusClass,
            false
        );
        downloadForm.addEventListener('animationend', removeFocusClass, false);
        downloadForm.addEventListener('oanimationend', removeFocusClass, false);
    }

    Array.from(downloadButtons).forEach((button) => {
        button.addEventListener('click', (e) => {
            // If the download form is not in view
            if (!isInViewport(downloadForm)) {
                var headerStyles = window.getComputedStyle(
                    document.querySelector('header.header')
                );
                var headerPosition = headerStyles.getPropertyValue('position');
                var scrollY = downloadForm.offsetTop - 16;

                if (headerPosition === 'fixed') {
                    var headerHeight = headerStyles.getPropertyValue('height');
                    scrollY -= parseInt(headerHeight, 10);
                }

                scrollToElement(scrollY, 500, 'easeInOutQuad', flashForm);
            } else {
                flashForm();
            }
        });
    });
}

// Source: http://pixelscommander.com/en/javascript/javascript-file-download-ignore-content-type/
function downloadFile(sUrl) {
    //iOS devices do not support downloading. We have to inform user about this.
    if (/(iP)/g.test(navigator.userAgent)) {
        //alert('Your device does not support files downloading. Please try again in desktop browser.');
        window.open(sUrl, '_blank');
        return false;
    }

    var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    var isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;

    //If in Chrome or Safari - download via virtual link click
    if (isChrome || isSafari) {
        //Creating new link node.
        var link = document.createElement('a');
        link.href = sUrl;
        link.setAttribute('target', '_blank');

        if (link.download !== undefined) {
            //Set HTML5 download attribute. This will prevent file from opening if supported.
            var fileName = sUrl.substring(
                sUrl.lastIndexOf('/') + 1,
                sUrl.length
            );
            link.download = fileName;
        }

        //Dispatching click event.
        if (document.createEvent) {
            var e = document.createEvent('MouseEvents');
            e.initEvent('click', true, true);
            link.dispatchEvent(e);
            return true;
        }
    }

    // Force file download (whether supported by server).
    if (sUrl.indexOf('?') === -1) {
        sUrl += '?download';
    }

    window.open(sUrl, '_blank');
    return true;
}

function commentsForm() {
    if ($('#news-post__comments-submission-form')) {
        const commentform = $('#news-post__comments-submission-form');
        const loader = $(
            '.news-post__comments-form-input-container-submit-overlay'
        );
        const feedback = $('.news-post__comments-form-feedback');

        commentform.on('submit', () => {
            loader.css('display', 'flex');
            $.ajax({
                type: 'post',
                url: window.location.origin + '/cms/wp-comments-post.php',
                data: commentform.serialize(),
                error: (error) => {
                    loader.css('display', 'none');
                    if (error.status === 409) {
                        feedback.css({
                            display: 'block',
                            background: '#f9b123',
                        });
                        feedback.html(
                            '<p>Please wait a while before posting your next comment.</p>'
                        );
                    } else {
                        feedback.css({
                            display: 'block',
                            background: '#B00020',
                        });
                        feedback.html(
                            '<p>We are unable to post your comment at this time, please try again soon.</p>'
                        );
                    }
                },
                success: () => {
                    loader.css('display', 'none');
                    feedback.css({ display: 'block', background: '#4BB543' });
                    feedback.html(
                        '<p>Thank you for your comment, it will appear once it has been approved by a member of our team.</p>'
                    );
                    commentform.trigger('reset');
                },
            });
            return false;
        });
    }
}
